import React from "react";
import clsx from "clsx";
import RoomBuilderErrors from "../RoomBuilderErrors";
import RadioSelect from "../../Selects/RadioSelect";

class RoomBuilderRoomTypes extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var roomTypesClasses = clsx({
      active: this.props.active_tab == "room_types",
      "tab-pane": true,
    });

    var inputs = this.props.all_room_types
      .sort((a, b) => a.code.localeCompare(b.code))
      .map((room_type) => {
        return {
          label_primary: room_type.code,
          label_secondary: room_type.name,
          status: room_type.status == "enabled" ? null : "disabled",
          id: room_type.id,
        };
      });

    //console.log("RoomBuilderRoomTypes", this.props.room.room_type_id, inputs);

    return (
      <div className={roomTypesClasses} id="room_types">
        {this.renderErrors()}
        <div className="row">
          <div className="col-md-12">
            <RadioSelect
              onChange={this.props.onChangeRoomType}
              inputs={inputs}
              selected_input={this.props.room.room_type_id}
            />
          </div>
        </div>
      </div>
    );
  }

  renderErrors() {
    if (RoomBuilderErrors.room_type(this.props.errors) != undefined) {
      var errors = RoomBuilderErrors.room_type(this.props.errors);
    }
    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });
      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }
}

export default RoomBuilderRoomTypes;
